export const PORTFOLIO_PATH = "/portfolio";

export const tabRoutes = {
  information: "information",
  taxCenter: "tax-center",
  taxForm: "tax-center/tax-form",
  documentCenter: "document-center",
  documents: "documents",
  investmentProfile: "investment-profile",
  settings: "settings",
  authorizedMembers: "authorized-members",
  keyParties: "key-parties",
};

export const profilePaths = (basePath: string) => ({
  home: `${basePath}/${tabRoutes.information}`,
  information: `${basePath}/${tabRoutes.information}`,
  taxCenter: `${basePath}/${tabRoutes.taxCenter}`,
  taxForm: `${basePath}/${tabRoutes.taxForm}`,
  documentCenter: `${basePath}/${tabRoutes.documentCenter}`,
  documents: `${basePath}/${tabRoutes.documents}`,
  investmentProfile: `${basePath}/${tabRoutes.investmentProfile}`,
  settings: `${basePath}/${tabRoutes.settings}`,
  authorizedMembers: `${basePath}/${tabRoutes.authorizedMembers}`,
  keyParties: `${basePath}/${tabRoutes.keyParties}`,
});

export const tabRoutesToProfilePaths = (
  basePath: string,
): Record<string, string> => {
  const paths = profilePaths(basePath);
  return {
    [tabRoutes.information]: paths.information,
    [tabRoutes.taxCenter]: paths.taxCenter,
    [tabRoutes.taxForm]: paths.taxForm,
    [tabRoutes.documentCenter]: paths.documentCenter,
    [tabRoutes.documents]: paths.documents,
    [tabRoutes.investmentProfile]: paths.investmentProfile,
    [tabRoutes.settings]: paths.settings,
    [tabRoutes.authorizedMembers]: paths.authorizedMembers,
    [tabRoutes.keyParties]: paths.keyParties,
  };
};

export const INVESTMENT_PROFILE_URL = (redirectUrl: string): string => {
  const search = new URLSearchParams({ redirectUrl });
  return `/profile/suitability?${search.toString()}`;
};
export const VERIFICATION_URL = (redirectUrl: string): string => {
  const search = new URLSearchParams({ redirectUrl });
  return `/profile/verification/identity-verification?${search.toString()}`;
};

export const VERIFICATION_URL_FOR_INDIVIDUAL = (
  redirectUrl: string,
): string => {
  const search = new URLSearchParams({ redirectUrl, forIndividual: "true" });
  return `/profile/verification/check?${search.toString()}`;
};

export const ACCREDITATION_URL = (
  additionalAccreditation: boolean,
  redirectUrl: string,
): string => {
  const search = new URLSearchParams({ redirectUrl });

  if (additionalAccreditation) {
    return `/accreditation?${search.toString()}`;
  }

  return `/profile/accreditation?${search.toString()}`;
};
